export const anneeRecolteCible = (rootGetters) => {
  const anneeActive = rootGetters['application/anneeRecolteActive']
  return anneeActive != null ? anneeActive : rootGetters['application/anneeRecolteEnCours']
}

export default anneeRecolteCible
